import Vue from 'vue'
import Landing from './MarketingHome.vue'
import axios from 'axios'
import Spinner from 'vue-simple-spinner'
import router from './router'
import Multiselect from 'vue-multiselect'
import VTooltip from 'v-tooltip'
import {BModal} from 'bootstrap-vue'
import store from '@/store/store'

import 'vue-multiselect/dist/vue-multiselect.min.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import '@/assets/css/bootstrap-modal.css'

import '@/assets/css/tooltip.css'
import '@/assets/css/tailwind.css'
import * as Localized from '../../localizationConfig'
Vue.prototype.Localized = Localized.default

Vue.config.productionTip = false
Vue.prototype.axios = axios
Vue.prototype.$scrollToTop = () => window.scrollTo(0, 0)
Vue.use(VTooltip, {
  defaultHideOnTargetClick: true
})
Vue.component('vue-simple-spinner', Spinner)
Vue.component('multiselect', Multiselect)
Vue.component('b-modal', BModal)

new Vue({
  router,
  store,
  render: h => h(Landing)
}).$mount('#app')
